/**
 * @author Tommy Brière
 * @copyright (c) 2013 Groupe PVP
 * @fileoverview Simple event system. Component can bind on this class to receive events
 **/
(function ($g) {
    "use strict";

    /*function time() {
        if (window.performance && performance.now) {
            return performance.now();
        }
        return new Date().getTime();
    } */   

    function Signal() {
        var me = this;
        var events = [];

        /**
         * Add a function to call at each trigger
         * @param f function
         * @return undefined
         */
        this.bind = function (f) {
            events.push(f);
        };

        this.hasEvents = function () {
            return (events.length > 0);
        };

        this.once = function (f) {
            function exec() {
                var args = Array.prototype.slice.call(arguments);
                me.unbind(exec);
                f.apply(null, args);
            }
            me.bind(exec);
        };

        /**
         * Remove a function added with bind
         * @param f function
         * @return undefined
         */
        this.unbind = function (f) {
            var i = 0;
            while (i < events.length) {
                if (events[i] == f) {
                    events.splice(i, 1);
                } else {
                    i++;
                }
            }
        };

        /**
         * Call all binded functions
         * @return undefined
         */
        this.trigger = function () {
            var args = Array.prototype.slice.call(arguments);
            var eve = events.slice();
            if (eve) {
                for (var i = 0; i < eve.length; i++) {
                    try {
                        //var before = time();
                        eve[i].apply(null, args);
                        /*var after = time();
                        var delta = after-before;
                        if (delta > 20) {
                            $g.warning("slow trigger", eve[i], args, delta);
                            
                        }*/
                    } catch (ex) {
                        $g.exception(ex);
                    }
                }
            }
        };
        
        this.unbindAll = function() {
            events = [];
        };
    }

    $g.Signal = Signal;

})(PVPGEngine);